import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { CurrencySymbolComponent } from '../../../../../core/components/currency-symbol/currency-symbol.component';
import { AmountPipe } from '../../../../../core/pipes/amount.pipe';
import { AuthService } from '../../../../auth/auth.service';
import { DashboardEngineService } from '../../../services/dashboard-engine.service';

@Component({
  selector: 'app-subscription-billing-card',
  standalone: true,
  imports: [NgClass, AmountPipe, MatIconModule, MatProgressSpinnerModule, RouterLink, CurrencySymbolComponent],
  templateUrl: './subscription-billing-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionBillingCardComponent implements OnChanges {
  private engine = inject(DashboardEngineService);
  private auth = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  @Input() dashboardType!: string;
  @Input() widgetId = 'subscriptionSummary';
  @Input() filters: any = {};
  @Input() requiredPermission?: string;

  get hasPermission(): boolean {
    return !this.requiredPermission || this.auth.canAccess([this.requiredPermission]);
  }

  data: any = null;
  loading = false;
  error: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasPermission) return;
    if (this.dashboardType) this.fetchData();
  }

  private fetchData(): void {
    this.loading = true;
    this.engine
      .getWidgetData(this.dashboardType, this.widgetId, this.filters)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          this.data = res.record?.data?.data ?? res.record?.data ?? res.record ?? {};
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (err: any) => {
          this.error = err.status === 403 ? 'Access restricted' : 'Unable to load data';
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
